import { render, staticRenderFns } from "./AvatarUnit2.vue?vue&type=template&id=0328e65b&scoped=true&"
import script from "./AvatarUnit2.vue?vue&type=script&lang=js&"
export * from "./AvatarUnit2.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUnit2.vue?vue&type=style&index=0&id=0328e65b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328e65b",
  null
  
)

export default component.exports